import { Box, Typography, Button, Chip, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

export default function FormHeader({ definition = {}, submitLabel = "Save", editing = false, onToggleEdit, onCancel, onCopy, onSubmit }) {
  const creating = submitLabel === "Create";
  return (
    <Box data-form-toolbar sx={{ position: "sticky", top: 64, zIndex: 10, mb: 2, mx: { xs: -2, md: -3, xl: -4 }, px: { xs: 2, md: 3, xl: 4 }, py: 1.5, borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} justifyContent="space-between" alignItems={{ xs: "stretch", md: "center" }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
          <Button type="button" color="inherit" onClick={onCancel} startIcon={<ArrowBackIcon />} sx={{ flexShrink: 0 }}>Back</Button>
          <Box sx={{ minWidth: 0, borderLeft: "1px solid", borderColor: "divider", pl: 2 }}>
            <Typography variant="overline" sx={{ color: "text.secondary", fontSize: 10, letterSpacing: 1.2 }}>Record details</Typography>
            <Typography component="h1" variant="h6" sx={{ overflowWrap: "anywhere", lineHeight: 1.3 }}>{definition.title || "Details"}</Typography>
          </Box>
        </Stack>
        <Stack direction="row" useFlexGap spacing={1} flexWrap="wrap" alignItems="center">
          <Chip label={creating ? "New record" : editing ? "Editing" : "View only"} size="small" variant="outlined" color={editing || creating ? "primary" : "default"} />
          {!creating && <Button type="button" variant="outlined" onClick={onCopy} startIcon={<ContentCopyOutlinedIcon />}>Copy</Button>}
          {!creating && <Button type="button" variant="outlined" onClick={onToggleEdit} startIcon={editing ? undefined : <EditOutlinedIcon />} color={editing ? "inherit" : "primary"}>{editing ? "Cancel" : "Edit"}</Button>}
          {(editing || creating) && <Button type="button" variant="contained" onClick={onSubmit} startIcon={<SaveOutlinedIcon />}>{submitLabel}</Button>}
        </Stack>
      </Stack>
    </Box>
  );
}
